import { render, staticRenderFns } from "./mo-loading-bar.html?vue&type=template&id=54a28675&external"
import script from "./mo-loading-bar.ts?vue&type=script&lang=ts&external"
export * from "./mo-loading-bar.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-loading-bar.vue?vue&type=style&index=0&id=54a28675&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/9/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a28675')) {
      api.createRecord('54a28675', component.options)
    } else {
      api.reload('54a28675', component.options)
    }
    module.hot.accept("./mo-loading-bar.html?vue&type=template&id=54a28675&external", function () {
      api.rerender('54a28675', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-loading-bar/mo-loading-bar.vue"
export default component.exports